import React from "react";
import {isFuture, parseISO} from "date-fns";

import {sum} from "@pg-mono/nodash";
import {dateTimeFormat, formatDate, numberFormat, pluralize} from "@pg-mono/string-utils";

import {IRangeQuery} from "../../../request/IRangeQuery";

interface IProps {
    fontSize?: string;
    offer: {
        construction_date_range: IRangeQuery<string>;
        name: string;
        properties: number;
        stats: {
            all_house_types: Record<string, number>;
            properties_count_for_sale: number;
            ranges_area_min: number;
            ranges_area_max: number;
            ranges_price_min: number;
        } | null;
    };
}

export const OfferGeneratedDescriptionTextHouses: React.FunctionComponent<IProps> = (props) => {
    const {offer} = props;
    const fontSize = props.fontSize ? props.fontSize : "fs16";

    const futureEndDate = isFuture(parseISO(offer.construction_date_range.upper));
    const futureStartDate = isFuture(parseISO(offer.construction_date_range.lower));
    const upper = formatDate(props.offer.construction_date_range.upper, dateTimeFormat.quarter);
    const propertiesPlural = pluralize(["nowego", "nowych", "nowych"]);
    const housePlural = pluralize(["domu", "domy", "domów"]);
    const houseCountPlural = pluralize(["domu", "domów", "domów"]);
    const propertiesNewPlural = pluralize(["nowy", "nowe", "nowych"]);
    const arePlural = pluralize(["jest", "są", "jest"]);

    const allProperties = offer.properties ?? sum(Object.values(offer.stats?.all_house_types || {}));

    return (
        <>
            <p className={fontSize}>
                {futureEndDate || !upper
                    ? `Inwestycja obecnie jest w trakcie ${futureStartDate ? "planowania" : "budowy"} ${
                          upper ? `z planowanym na ${upper} roku terminem oddania do użytkowania` : ""
                      }`
                    : `Inwestycja ${offer.name} została wybudowana i oddana do użytkowania ${upper ? `w ${upper} roku` : ""}.`}
            </p>

            {(offer.properties || offer.stats?.all_house_types) && (
                <p className={fontSize}>
                    Cały projekt składa się z {` ${allProperties} ${propertiesPlural(allProperties)} ${houseCountPlural(allProperties)}`}.
                </p>
            )}

            <p className={fontSize}>
                {offer.stats?.properties_count_for_sale ? (
                    `Aktualnie w inwestycji ${offer.name} w sprzedaży ${arePlural(offer.stats.properties_count_for_sale)} ${
                        offer.stats.properties_count_for_sale
                    } ${propertiesNewPlural(offer.stats.properties_count_for_sale)} ${housePlural(offer.stats.properties_count_for_sale)} ${
                        !!offer.stats.ranges_area_min
                            ? ` o powierzchni ${
                                  offer.stats.ranges_area_min === offer.stats.ranges_area_max
                                      ? ` ${offer.stats.ranges_area_min}`
                                      : `od ${offer.stats.ranges_area_min} do ${offer.stats.ranges_area_max}`
                              } metrów kwadratowych`
                            : ""
                    } ${offer.stats.ranges_price_min ? `, w cenie od ${numberFormat(offer.stats.ranges_price_min)} zł` : ""}.`
                ) : (
                    <>Aktualnie w inwestycji {offer.name} nie ma nowych domów w sprzedaży.</>
                )}
            </p>
        </>
    );
};
import React from "react";
import {isFuture, parseISO} from "date-fns";

import {sum} from "@pg-mono/nodash";
import {dateTimeFormat, formatDate, numberFormat, pluralize} from "@pg-mono/string-utils";

import {IRangeQuery} from "../../../request/IRangeQuery";

interface IProps {
    fontSize?: string;
    offer: {
        construction_date_range: IRangeQuery<string>;
        name: string;
        properties: number;
        stats: {
            all_house_types: Record<string, number>;
            properties_count_for_sale: number;
            ranges_area_min: number;
            ranges_area_max: number;
            ranges_price_min: number;
        } | null;
    };
}

export const OfferGeneratedDescriptionTextHouses: React.FunctionComponent<IProps> = (props) => {
    const {offer} = props;
    const fontSize = props.fontSize ? props.fontSize : "fs16";

    const futureEndDate = isFuture(parseISO(offer.construction_date_range.upper));
    const futureStartDate = isFuture(parseISO(offer.construction_date_range.lower));
    const upper = formatDate(props.offer.construction_date_range.upper, dateTimeFormat.quarter);
    const propertiesPlural = pluralize(["nowego", "nowych", "nowych"]);
    const housePlural = pluralize(["domu", "domy", "domów"]);
    const houseCountPlural = pluralize(["domu", "domów", "domów"]);
    const propertiesNewPlural = pluralize(["nowy", "nowe", "nowych"]);
    const arePlural = pluralize(["jest", "są", "jest"]);

    const allProperties = offer.properties ?? sum(Object.values(offer.stats?.all_house_types || {}));

    return (
        <>
            <p className={fontSize}>
                {futureEndDate || !upper
                    ? `Inwestycja obecnie jest w trakcie ${futureStartDate ? "planowania" : "budowy"} ${
                          upper ? `z planowanym na ${upper} roku terminem oddania do użytkowania` : ""
                      }`
                    : `Inwestycja ${offer.name} została wybudowana i oddana do użytkowania ${upper ? `w ${upper} roku` : ""}.`}
            </p>

            {(offer.properties || offer.stats?.all_house_types) && (
                <p className={fontSize}>
                    Cały projekt składa się z {` ${allProperties} ${propertiesPlural(allProperties)} ${houseCountPlural(allProperties)}`}.
                </p>
            )}

            <p className={fontSize}>
                {offer.stats?.properties_count_for_sale ? (
                    `Aktualnie w inwestycji ${offer.name} w sprzedaży ${arePlural(offer.stats.properties_count_for_sale)} ${
                        offer.stats.properties_count_for_sale
                    } ${propertiesNewPlural(offer.stats.properties_count_for_sale)} ${housePlural(offer.stats.properties_count_for_sale)} ${
                        !!offer.stats.ranges_area_min
                            ? ` o powierzchni ${
                                  offer.stats.ranges_area_min === offer.stats.ranges_area_max
                                      ? ` ${offer.stats.ranges_area_min}`
                                      : `od ${offer.stats.ranges_area_min} do ${offer.stats.ranges_area_max}`
                              } metrów kwadratowych`
                            : ""
                    } ${offer.stats.ranges_price_min ? `, w cenie od ${numberFormat(offer.stats.ranges_price_min)} zł` : ""}.`
                ) : (
                    <>Aktualnie w inwestycji {offer.name} nie ma nowych domów w sprzedaży.</>
                )}
            </p>
        </>
    );
};
